import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  clearNotificationsOnNav,
  Notification,
  removeNotification
} from "store/notification";
import { PolyIcon } from "elements";
import { State } from "store";
import { RouteComponentProps, withRouter } from "react-router";
import { THEME_DEFAULT } from "store/userMeta";

export const Notice: React.FC<Notification> = props => {
  const dispatch = useDispatch();
  const [notificationTimeout, setNotificationTimeout] = useState<
    NodeJS.Timeout | undefined
  >(undefined);

  const classes = [
    "notification",
    props.id,
    props.type,
    `${props.type}-notification`
  ].join(" ");

  let icon = {
    info: "chat",
    error: "warning_triangle",
    success: "success",
    beta: ""
  }[props.type];

  useEffect(() => {
    if (props.dismiss && typeof props.dismiss === "number") {
      let timeout = setTimeout(() => {
        dispatch(removeNotification(props.id));
      }, props.dismiss);
      setNotificationTimeout(timeout);
    }
  }, [dispatch, props.id, props.dismiss]);

  return (
    <div className={classes} data-testid="notification">
      <div className="icon">
        <PolyIcon icon={icon} />
      </div>
      <div className={`message${props.type === "beta" ? " beta" : ""}`}>
        {props.message}
      </div>
      {props.dismiss !== "NOT_DISMISSIBLE" && (
        <div
          className="dismiss"
          data-testid="dismiss-notification"
          onClick={() => {
            if (notificationTimeout) {
              clearTimeout(notificationTimeout);
            }
            dispatch(removeNotification(props.id));
          }}
        >
          <PolyIcon icon="clear_x" />
        </div>
      )}
    </div>
  );
};

/**
 * A class component gives us an easier "did props change" than hooks, so a class in this case.
 */
class NotificationClearer extends React.PureComponent<
  RouteComponentProps & { clearNotifications: () => {} }
> {
  componentDidUpdate(nextProps: Readonly<RouteComponentProps>): void {
    const { location } = this.props;
    const { location: nextLocation } = nextProps;
    if (location.pathname !== nextLocation.pathname) {
      this.props.clearNotifications();
    }
  }

  render() {
    return <></>;
  }
}

const Clearer = connect(null, { clearNotifications: clearNotificationsOnNav })(
  withRouter(NotificationClearer)
);

export const Notifications: React.FC = () => {
  const notifications: State["notifications"] = useSelector(
    (state: State) => state.notifications
  );
  const theme = useSelector((state: State) => {
    return state.userMeta?.theme ?? THEME_DEFAULT;
  });
  const isBeta = notifications["beta"]?.type === "beta";

  return (
    <div
      className={`${
        theme === "LIGHT" ? "theme-light " : ""
      }notifications-container${isBeta ? " beta" : ""}`}
    >
      <Clearer />
      {Object.values(notifications).map(notification => {
        return <Notice key={notification.id} {...notification} />;
      })}
    </div>
  );
};
